import Formats from './formats';
import { ACCOUNTS_TYPE, ITEMS_TYPE, STORES_TYPE } from './types';
import { OTHER_ROUTES } from 'utils/routes';

export const getData = (data: any) => {
  if (data) return data[Object.keys(data)[0]];
};

export const addLabelToItem = (item: string) => ({
  id: item,
  label: item,
});

export const isEmpty = (data: any) => {
  return (
    data === null ||
    data === undefined ||
    getData(data) === null ||
    getData(data) === undefined ||
    (getData(data) && getData(data).length === 0)
  );
};

export const isValueDefined = (value: any): boolean => value !== undefined && value !== null;

export const formatTo = (format: any, value: number) => {
  switch (format) {
    case 'currency':
      return Formats.currency(value);
    case 'currency-cents':
      return Formats.currency(value, 2);
    case 'number':
      return Formats.number(value);
    case 'percentage':
      return Formats.percentage(value);
    case 'number-2':
      return Formats.number(value, 2);
    default:
      return value;
  }
};

export const applyStyle = (field: any, val: number) => {
  switch (field) {
    case 'salesDelta':
    case 'unitsDelta':
    case 'podDelta':
      if (val !== null && val !== 0) {
        return val > 0 ? { color: '#28a745' } : { color: '#dc3545' };
      }
      break;
    default:
      return {};
  }
};

export const isValidEmail = (value: string): boolean => {
  var re = /\S+@\S+\.\S+/;
  if (re.test(value)) {
    return true;
  }
  return false;
};

export const getTabNamesBySelectedTab = (selectedTab: string) => {
  if (selectedTab === ACCOUNTS_TYPE) return [STORES_TYPE, ITEMS_TYPE];
  if (selectedTab === ITEMS_TYPE) return [ACCOUNTS_TYPE, STORES_TYPE];
  if (selectedTab === STORES_TYPE) return [ACCOUNTS_TYPE, ITEMS_TYPE];
};

/**
 * Getting UPC from backend item (structure upc as array of types)
 */
export const getUpcFromItem = (item: any) => {
  let result = 'N/A';
  try {
    result = item.upc.find((upc) => upc.type === 'GTIN').value;
  } catch (e) {
    console.error(e);
  }
  return result;
};

export const getDetailsNavigation = (
  key: string,
  entity: any,
  data: any,
  defaultName: string = ''
): any => {
  return {
    pathname: OTHER_ROUTES.DETAILS,
    search: `?${entity}=${encodeURIComponent(key)}&${entity}_name=${encodeURIComponent(
      defaultName !== '' ? defaultName : data.name
    )}`,
  };
};

export const getGroupDetailsNavigation = (key: string, entity: any, groupId: string): any => {
  return {
    pathname: OTHER_ROUTES.GROUP_DETAILS,
    search: `?${entity}=${encodeURIComponent(key)}&${entity}_name=${encodeURIComponent(
      key
    )}&group_id=${groupId}`,
  };
};

/**
 * Getting a key in an Object by its value
 * @param obj
 * @param value
 */
export const getKeyByValue = (obj, value) => {
  return Object.keys(obj).find((key) => obj[key] === value);
};

export const getKeyByValueAsNumber = (obj, value) => {
  const key = Number.parseInt(getKeyByValue(obj, value));
  if (Number.isNaN(key)) {
    throw new Error('Error while trying to parse key to number');
  }
  return key;
};

export const titleCase = (str) => {
  var splitStr = str.toLowerCase().split(' ');
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(' ');
};

export const deepEqual = (object1, object2) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);

    if ((areObjects && !deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
      return false;
    }
  }

  return true;
};

const isObject = (object) => {
  return object != null && typeof object === 'object';
};

export const getArrayOfKeys = (itemArray: Array<any>, key: string) => {
  const arr =
    itemArray && itemArray.length > 0
      ? itemArray.map((item) => {
          return item[key];
        })
      : [];
  return arr;
};
